import styled from 'styled-components';

export const StyledVisitContinuouslyUsedMedicineTableRowMedicine = styled.div`
   display: inline-flex;
   align-items: center;
   gap: 6px;
`;

StyledVisitContinuouslyUsedMedicineTableRowMedicine.displayName = 'StyledVisitContinuouslyUsedMedicineTableRow';
